import Vue from 'vue';
import i18n from '@/i18n';

function FaturaSituacao(value: string): string {
  switch (value) {
    case 'canceled':
      return i18n.t('faturas.situacoes.cancelado') as string;
    case 'refunded':
      return i18n.t('faturas.situacoes.reembolsado') as string;
    case 'expired':
    case 'overdue':
      return i18n.t('faturas.situacoes.vencido') as string;
    case 'in_protest':
      return i18n.t('faturas.situacoes.protesto') as string;
    case 'chargeback':
      return i18n.t('faturas.situacoes.estorno') as string;
    case 'partially_paid':
      return i18n.t('faturas.situacoes.parcial') as string;
    case 'authorized':
      return i18n.t('faturas.situacoes.autorizado') as string;
    case 'paid':
    case 'received':
    case 'confirmed':
      return i18n.t('faturas.situacoes.pago') as string;
    case 'pending':
      return i18n.t('faturas.situacoes.pendente') as string;
    case 'externally_paid':
    case 'received_in_cash':
      return i18n.t('faturas.situacoes.externo') as string;
    default:
    case 'empty':
      return i18n.t('faturas.situacoes.indisponivel') as string;
  }
}

function FaturaCor(value: string, prefix = ''): string {
  switch (value) {
    case 'refunded':
    case 'expired':
    case 'overdue':
    case 'in_protest':
    case 'chargeback':
      return `${prefix}danger`;
    case 'partially_paid':
    case 'canceled':
      return `${prefix}warning`;
    case 'authorized':
    case 'externally_paid':
    case 'received_in_cash':
    case 'paid':
    case 'received':
    case 'confirmed':
      return `${prefix}success`;
    default:
    case 'pending':
    case 'empty':
      return `light`;
  }
}

function FaturaBadge(value: string, prefix = ''): string {
  switch (value) {
    case 'refunded':
    case 'expired':
    case 'overdue':
    case 'in_protest':
    case 'chargeback':
      return `${prefix}danger`;
    case 'partially_paid':
    case 'canceled':
      return `${prefix}warning`;
    case 'authorized':
    case 'externally_paid':
    case 'received_in_cash':
    case 'paid':
    case 'received':
    case 'confirmed':
      return `${prefix}success`;
    default:
    case 'pending':
    case 'empty':
      return `${prefix}soft-secondary`;
  }
}

function FaturaTipo(value: string): string {
  switch (value) {
    case 'pix':
      return 'PIX À Vista';
    case 'pix_entrada':
      return 'PIX Entrada';
    case 'pix_parcela':
      return 'PIX Parcela';
    case 'cartao':
      return 'Cartão';
    case 'boleto':
    case 'avista':
      return 'Boleto À Vista';
    case 'boleto1':
    case 'entrada':
      return 'Boleto Entrada';
    case 'boleto2':
    case 'parcela':
      return 'Boleto Parcela';
    default:
      return 'Boleto';
  }
}

Vue.filter('FaturaSituacao', FaturaSituacao);
Vue.filter('FaturaCor', FaturaCor);
Vue.filter('FaturaBadge', FaturaBadge);
Vue.filter('FaturaTipo', FaturaTipo);
